import { z } from 'zod';
export const Debt = z.object({
    id: z.number().int(),
    name: z.string().min(1).max(160),
    sub: z.string().max(120).nullable(),
    interest_rate: z.string().nullable(),
    balance: z.number().int(),
});
export const CreateDebtRequest = z.object({
    name: z.string().min(1).max(160),
    sub: z.string().max(120).nullable().optional(),
    interest_rate: z.number().min(0).max(99.99).nullable().optional(),
    balance: z.number().int().min(0),
});
export const UpdateDebtRequest = z
    .object({
    name: z.string().min(1).max(160).optional(),
    sub: z.string().max(120).nullable().optional(),
    interest_rate: z.number().min(0).max(99.99).nullable().optional(),
    balance: z.number().int().min(0).optional(),
})
    .refine((v) => Object.keys(v).length > 0, { message: 'no fields provided' });
